import React, { useEffect, useState } from 'react';

type Guide = {metrics:{frame_height_m:number;active_lift_m:number};houses:{id:string;height:number;top:number;calibrated:boolean}[]};
export default function TrackerHeightGuide({controls,selected=false}:{controls:React.MutableRefObject<any>;selected?:boolean}) {
  const [guide,setGuide]=useState<Guide|null>(null);
  useEffect(()=>{
    let frame=0;
    const refresh=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>setGuide(controls.current?.getTrackerHeightGuide?.(selected)??null));};
    refresh();window.addEventListener('project-dimensions-changed',refresh);
    return()=>{cancelAnimationFrame(frame);window.removeEventListener('project-dimensions-changed',refresh);};
  },[controls,selected]);
  return <div data-testid="tracker-height-guide" style={{fontSize:12,lineHeight:1.45,marginTop:8,color:'#b8d2e0'}}>
    {guide?.houses.map(h=><p key={h.id} style={{margin:'6px 0'}}>Kundenhaus: <strong>{h.height.toFixed(2)} m hoch</strong> · oberster Punkt {h.top.toFixed(2)} m über Boden.
      {!h.calibrated&&<> Noch ohne Referenzmaß: zuerst die Gebäudehöhe im Kundenprojekt übernehmen.</>}</p>)}
    <p style={{margin:'6px 0'}}>Die Aufstellhöhe legt die Trackerbasis über dem Boden fest. Bei einem Schrägdach zählt die Höhe an der Montagestelle, nicht die Firsthöhe.</p>
    {guide&&<p style={{margin:'6px 0'}}>Gestell: {guide.metrics.frame_height_m.toFixed(2)} m; zusätzlicher Hub bei Nachführung: {guide.metrics.active_lift_m.toFixed(2)} m. Einstellbar unter „Modul- und Trackermaße“.</p>}
  </div>;
}
